import { render } from "./RjRegion.vue?vue&type=template&id=5353217c"
import script from "./RjRegion.vue?vue&type=script&lang=js"
export * from "./RjRegion.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__